'use client'

import { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import Alert from '@audioeye-marketing/ui/src/components/Alert'
import LinkButton from '@audioeye-marketing/ui/src/components/LinkButton'
import AlertTriangle from '@audioeye/ui-icons/Line/Alerts/AlertTriangle'

const DraftModeAlert = () => {
  const searchParams = useSearchParams()
  const [showAlert, setShowAlert] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setShowAlert(!searchParams.has('_storyblok'))
  }, [searchParams])

  if (!showAlert) return null

  return (
    <Alert
      startDecorator={<AlertTriangle />}
      variant="soft"
      color="danger"
      endDecorator={
        <LinkButton
          onClick={() => {
            setIsLoading(true)
          }}
          loading={isLoading}
          variant="soft"
          color="danger"
          sx={{ mr: 1 }}
          href="/api/draft/disable/"
          prefetch={false}
        >
          Disable
        </LinkButton>
      }
      sx={{ position: 'fixed', bottom: '24px', right: '24px', width: '500px', zIndex: 99999 }}
    >
      You are currently in draft mode.
    </Alert>
  )
}

export default DraftModeAlert
